import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import clsx from 'clsx';
import { DateTime } from 'luxon';
import { FC, ReactNode } from 'react';

import { useInputStyles } from './internal/InternalTextField';

export type DateTimeInputProps = {
  readonly label: string;
  readonly value: DateTime | null;
  readonly onChange: (value: DateTime | null) => void;
  readonly onBlur?: () => void;
  readonly minDate?: DateTime;
  readonly disablePast?: boolean;
  readonly showError?: boolean;
  readonly errorMsg?: ReactNode;
  readonly dense?: boolean;
  readonly autoFocus?: boolean;
  readonly readOnly?: boolean;
};

const DateTimeInput: FC<DateTimeInputProps> = ({
  value,
  minDate,
  disablePast,
  label,
  dense,
  onChange,
  onBlur,
  showError,
  errorMsg,
  autoFocus,
  readOnly,
}: DateTimeInputProps) => {
  const classes = useInputStyles();
  return (
    <DesktopDateTimePicker<DateTime>
      slotProps={{
        textField: {
          error: showError,
          helperText: showError ? errorMsg : null,
          fullWidth: true,
          variant: 'outlined',
          size: 'small',
          FormHelperTextProps: { role: 'alert' },
          autoFocus,
          label,
          classes: {
            root: clsx({
              [classes.inputDense]: dense,
            }),
          },
          onBlur,
        },
      }}
      value={value}
      disablePast={disablePast}
      minDate={minDate}
      onChange={(newValue: DateTime | null) => {
        if (value?.toISO() !== newValue?.toISO()) {
          onChange(newValue);
        }
      }}
      readOnly={readOnly}
      disabled={readOnly}
    />
  );
};

export default DateTimeInput;
